import Vue from "vue";
import Router from "vue-router";
import Editor from "@/components/Editor";
import cognito from "@/cognito";
import Login from "@/components/Login";
import Signup from "@/components/Signup";
import Confirm from "@/components/Confirm";
import PasswordReset from "@/components/PasswordReset";
import ForgetPassword from "@/components/ForgetPassword";

Vue.use(Router);

const requireAuth = (to, from, next) => {
  cognito
    .isAuthenticated()
    .then(session => {
      //console.log("Session:" + JSON.stringify(session));
      next();
    })
    .catch(session => {
      next({
        path: "/login",
        query: { redirect: to.fullPath }
      });
    });
};

const logout = (to, from, next) => {
  cognito.logout();
  next("/login");
};

export default new Router({
  mode: "history",
  routes: [
    { path: "/", redirect: "editor" },
    {
      path: "/editor",
      name: "Editor",
      component: Editor,
      beforeEnter: requireAuth
    },
    {
      path: "/login",
      name: "Login",
      component: Login
    },
    {
      path: "/singup",
      name: "Signup",
      component: Signup
    },
    {
      path: "/confirm",
      name: "Confirm",
      component: Confirm
    },
    {
      path: "/passwordreset",
      name: "PasswordReset",
      component: PasswordReset
    },
    {
      path: "/forgetpassword",
      name: "ForgetPassword",
      component: ForgetPassword
    },
    { path: "/logout", beforeEnter: logout }
  ]
});



// WEBPACK FOOTER //
// ./src/router/index.js